/* globals lp,Class */
var _ = require('lodash');

module.exports = Class.create(lp.pom.VisibleElementModel, {
  initialize: function($super, element, modelData) {
    $super(element, modelData);
    this.addBreakpointModifyableAttributes({
      geometry:{
        visible: true,
        fitWidthToPage: true,
        margin: true,
        size: {
          width: true,
          height: true
        },
        backgroundImageApply: true,
        borderLocation: true, // explicitly setting here, too.
        borderApply: {
          top: true,
          right: true,
          left: true,
          bottom: true
        },
        savedBorderState: {
          left: true,
          right: true
        },
        keepCircular: true,
        cornerRadius: {
          tl: true,
          tr: true,
          bl: true,
          br: true
        }
      },
      style: {
        background: {
          image: true,
          backgroundColor: true,
          backgroundPosition: true,
          backgroundRepeat: true,
          savedBackgroundColor: true,
          gradient: {
            from: true,
            to: true
          },
          fillType: true,
          autoGradient: true,
          reverseGradient: true,
          opacity: true
        },
        border: true
      }
    });

    this.addBreakpointAllowDuplicateAttributes({
      geometry:{
        visible: true,
        fitWidthToPage: true,
        backgroundImageApply: true,
        borderLocation: true, //explicitly setting
        borderApply: {
          top: true,
          right: true,
          left: true,
          bottom: true
        },
        savedBorderState: {
          left: true,
          right: true
        }
      },
      style: {
        background: {
          backgroundRepeat: true,
          backgroundPosition: true,
          savedBackgroundColor: true,
          image: true
        },
        border: true
      }
    });
  },

  // TODO-TR: LP-6616 move this up to element_model
  addBreakpointModifyableAttributes: function(object) {
    _.merge(this.breakpointModifyableAttributes, object);
  },

  addBreakpointAllowDuplicateAttributes: function(object) {
    _.merge(this.breakpointAllowDuplicateAttributes, object);
  },

  getSize: function() {
    return {
      width: this.element.getParentElement().getContentWidth(),
      height: this.getHeight()
    };
  },

  getWidth: function() {
    return this.element.getParentElement() ? this.element.getParentElement().getContentWidth() : 0;
  },

  shouldApplyBackgroundImage: function() {
    if (this.exists('geometry.backgroundImageApply')) {
      return this.get('geometry.backgroundImageApply');
    } else {
      return true; // backwards compat
    }

  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-block/block_model.js
// module id = 510
// module chunks = 0 1